import { useState } from "react";
import { useContextDashboardContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const UseFormMonthByMonthProfitChart = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const {
    filterMetricsFilterDashboard: { endDate, startDate, interval },
  } = useContextDashboardContext();

  const { setDataProfitableValues } = useContextDashboardContext();

  const [loading, setLoading] = useState(false);

  const handleCreatePerfilAcesso = async () => {
    setLoading(true);

    return api
      .get(
        `/metrics/profitChart?startDate=${startDate}&endDate=${endDate}&interval=${interval}`
      )
      .then((res) => {
        setDataProfitableValues(res.data);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleCreatePerfilAcesso, loading };
};
